import * as Yup from "yup";
import checkout from "./form13";

const {
  formField13: { totalTaxTNDN, totalExpense },
} = checkout;

const validation13 = Yup.object().shape({
  [totalTaxTNDN.name]: Yup.number().required(totalTaxTNDN.errorMsg),
  [totalExpense.name]: Yup.number().required(totalExpense.errorMsg),
});

export default validation13;
